import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { confirmSignUp } from '@aws-amplify/auth';
import LogoLink from './LogoLink.jsx';

function ConfirmEmail() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [username, setUsername] = useState(state?.username || ''); // Email as username
  const [code, setCode] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!username) {
      setError('Email is required to confirm your account. Please re-enter.');
      navigate('/signup');
    }
  }, [username, navigate]);

  const handleConfirm = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
  
    if (!username.trim()) {
      setError('Email (username) is required.');
      return;
    }
  
  
    try {
      await confirmSignUp(username.trim(), code.trim());
      setSuccess(true);
      alert('Email confirmed successfully! Redirecting to sign in...');
      // No /login route exists; /signup holds the Cognito sign-in button.
      navigate('/signup');
    } catch (err) {
      console.error('Error confirming email:', err.message);
      setError(err.message || 'Failed to confirm email. Please try again.');
    }
  };
  
  return (
    <div style={{ maxWidth: '400px', margin: '0 auto', padding: '20px' }}>
      <LogoLink className="logo-link--card" />
      <h2>Confirm Your Email</h2>
      {success && <p style={{ color: 'green' }}>Email confirmed successfully!</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleConfirm}>
        <label>Email (used as Username)</label>
        <input
          type="text"
          placeholder="Enter your email"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <label>Verification Code</label>
        <input
          type="text"
          placeholder="Enter the verification code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        />
        <button type="submit">Confirm Email</button>
      </form>
    </div>
  );
}

export default ConfirmEmail;
